import { useState, useEffect } from "react";

const Selector = ({ tabsData, clickHandler, active }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(active);
  
  useEffect(() => {
    setActiveTabIndex(active)
  }, [active]);

  return (
    <div className="flex bg-gray-100 rounded-lg p-1 border border-gray-200">
      {tabsData.map((tab, idx) => {
        return (
          <button
            key={idx}
            className={`flex-1 px-4 py-3 text-sm font-medium rounded-md transition-all duration-200
                        ${
                          idx === activeTabIndex
                            ? "bg-white text-blue-700 shadow-sm border border-gray-200 font-semibold"
                            : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                        }
                      `}
            onClick={() => {
              clickHandler(idx)
              setActiveTabIndex(idx)
            }}
          >
            <div className="flex items-center justify-center">
              <span className="whitespace-nowrap">{tab}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default Selector;